import React, { useCallback } from 'react';
import ComponentPropTypes from './ComponentPropTypes';
import NodeSelection from '../../NodeSelection/NodeSelection';

const NodeSelectionComponent = ({ model, value, onChange }) => {
  const _onChange = useCallback(_value => {
    onChange(model, _value);
  }, [model, onChange]);

  return <NodeSelection selections={value} onSelectionChanged={_onChange} />;
};

NodeSelectionComponent.propTypes = ComponentPropTypes;

export default React.memo(NodeSelectionComponent);
